import * as THREE from 'three';

import Stats from 'three/examples/jsm/libs/stats.module.js';
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader.js';
import { RGBMLoader } from 'three/examples/jsm/loaders/RGBMLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { DebugEnvironment } from 'three/examples/jsm/environments/DebugEnvironment.js';
import { RoughnessMipmapper } from 'three/examples/jsm/utils/RoughnessMipmapper.js';

import { MeshStandardNodeMaterial } from 'three/examples/jsm/nodes/Nodes.js';

import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

import { BufferGeometryUtils } from 'three/examples/jsm/utils/BufferGeometryUtils.js';

let camera, scene, container, stats;
let renderer;
let transition;
let mixer, mixer1;
let model;
let loader;
let controls;

let lumiereS, sphereTab = []

let animationStep = {
    frame: 0
};
// const gui = new dat.GUI();

const debugParameters = {
    modelScale: 1,
    mixerDuration: 0.7,
    mixerSetTime: 0,
    fogNear: 0.1,
    fog: 0,
    circleColor1: 0x324057,
    circleColor2: 0x060d19,
    dirLightColor: 0x7088ff,
    modeColor: 0x545454,
    modeColorZemin: 0x787878,
}
let pmremGenerator;
const clock = new THREE.Clock();

if (window.innerWidth >= 1200) {
    if ($("#human-model").length) {
        init();
    }
}

function scrollAnimation(model, camera) {
    setTimeout(() => {
        gsap.to(camera.position, {
            x: 8,
            y: -0.9,
            z: 2.4,
            ease: "none",
            duration: 0.1,
        })

        gsap.to(camera.rotation, {
            x: 0,
            y: -0.3,
            z: 0,
            ease: "none",
            duration: 0.1,
        })
    }, 500);

    if (model) {
        // Hand Zoom
        gsap.fromTo(camera.position, {
            x: 8,
            y: -0.9,
            z: 2.4,
        }, {
            x: 9,
            y: -1.6,
            z: 3,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + window.innerHeight + "px bottom",
                end: "top+=" + window.innerHeight + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: -0.3,
        }, {
            y: 0,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + window.innerHeight + "px bottom",
                end: "top+=" + window.innerHeight + "px top",
                scrub: 1.1,
            }
        })

        // Arm Zoom
        gsap.fromTo(camera.position, {
            x: 9,
            y: -1.6,
            z: 3,
        }, {
            x: 10.1,
            y: -1.1,
            z: 3,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 1300) + "px top",
                end: "top+=" + (window.innerHeight + 2300) + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: 0,
        }, {
            y: 0.4,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 1300) + "px top",
                end: "top+=" + (window.innerHeight + 2300) + "px top",
                scrub: 1.1,
            }
        })

        // Spine Zoom
        gsap.fromTo(camera.position, {
            x: 10.1,
            y: -1.1,
            z: 3,
        }, {
            x: 11.7,
            y: -1.2,
            z: -0.5,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 2700) + "px top",
                end: "top+=" + (window.innerHeight + 3700) + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: 0.4,
        }, {
            y: 2.18,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 2700) + "px top",
                end: "top+=" + (window.innerHeight + 3700) + "px top",
                scrub: 1.1,
            }
        })

        // Foot Zoom
        gsap.fromTo(camera.position, {
            x: 11.7,
            y: -1.2,
            z: -0.5,
        }, {
            x: 7.8,
            y: -2.7,
            z: 1.1,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 4100) + "px top",
                end: "top+=" + (window.innerHeight + 5100) + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: 2.18,
        }, {
            y: -0.75,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 4100) + "px top",
                end: "top+=" + (window.innerHeight + 5100) + "px top",
                scrub: 1.1,
            }
        })

        // Heart
        gsap.fromTo(camera.position, {
            x: 7.8,
            y: -2.7,
            z: 1.1,
        }, {
            x: 8.5,
            y: -1,
            z: 1.1,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 5500) + "px top",
                end: "top+=" + (window.innerHeight + 6500) + "px top",
                scrub: 1.1,
            }
        })

        gsap.fromTo(camera.rotation, {
            y: -0.75,
        }, {
            y: -0.6,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 5500) + "px top",
                end: "top+=" + (window.innerHeight + 6500) + "px top",
                scrub: 1.1,
            }
        })

        // Head Zoom
        gsap.fromTo(camera.position, {
            x: 8.5,
            y: -1,
            z: 1.1,
        }, {
            x: 8,
            y: -0.3,
            z: 1.3,

            scrollTrigger: {
                trigger: "body",
                start: "top+=" + (window.innerHeight + 6900) + "px top",
                end: "top+=" + (window.innerHeight + 7900) + "px top",
                scrub: 1.1,
            }
        })
    }
}

function init() {
    const container = document.getElementById('human-model-plane');
    camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.2, 2000);

    scene = new THREE.Scene();
    scene.fog = new THREE.Fog(0xDFE3E6, 1, 20);

    let dirLight = new THREE.DirectionalLight(debugParameters.dirLightColor, 1, 100);
    dirLight.position.set(-212, 33, 460); //default; light shining from top
    dirLight.intensity = 3;
    dirLight.castShadow = true;
    scene.add(dirLight);

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0xffffff, 0);
    renderer.outputEncoding = THREE.sRGBEncoding;

    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;

    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 2;

    pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    container.appendChild(renderer.domElement);

    loader = new GLTFLoader().load('./assets/model/plane.glb', function (gltf) {
        model = gltf.scene.children[0]

        gltf.scene.position.set(10, -4, 0)
        gltf.scene.scale.set(1, 1, 1)
        gltf.scene.rotation.set(0, -1.2, 0)

        mixer = new THREE.AnimationMixer(gltf.scene);
        gltf.animations.forEach((clip) => {
            mixer.clipAction(clip).play();
        });

        gltf.scene.traverse(function (child) {
            child.castShadow = true;

            if (child.isMesh) {
                child.material.color = new THREE.Color(0xffffff);
            }
        });

        if (model) {
            scrollAnimation(model, camera)
        }

        scene.add(gltf.scene);

        animate()
    });

    // Camera Position
    camera.position.set(8, -0.9, 2.4);
    camera.rotation.set(0, -0.3, 0);
    scene.add(camera);

    // const helper = new THREE.CameraHelper(dirLight.shadow.camera);
    // scene.add(helper);

    window.addEventListener('resize', onWindowResize);
}

function onWindowResize() {

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(window.innerWidth, window.innerHeight);

}

function animate() {
    requestAnimationFrame(animate);

    let delta = clock.getDelta();

    if (mixer) {
        mixer.update(delta * debugParameters.mixerDuration);
    }

    renderer.render(scene, camera);
}